@let historyValue = history();
@let metaInfoValue = metaInfo();

<div class="modal-header">
  @if (!compareItemListMode) {
    <h4 class="modal-title">
      {{'projectVersionHistoryPopup.title' | translate}}
      <a class="link ps-2" href="javascript:void(0)" data-gatm="global.label.help" (click)="openHELPLink()" tooltip [tooltipText]="'global.label.help' | translate">
        <app-svg-icon type="information_circle" [inline]="true"/>
      </a>
    </h4>
  }
  @if (compareItemListMode) {
    <h4 class="modal-title">{{'projectVersionHistoryPopup.title.compareItemListMode' | translate}}</h4>
  }
</div>

@if(historyValue) {
  <div class="modal-body pt-0">
    <div class="modal-body-inner">

      @if (compareItemListMode) {
        <div class="mb-3 row mb-0">
          <label class="col-md-12 col-form-label">{{'projectVersionHistoryPopup.label.compareItemListModeIntro' | translate}}</label>
        </div>
      }
      <div class="mb-3 row mb-0">
        <label class="col-md-3 col-form-label">{{'projectVersionHistoryPopup.label.project_name' | translate}}</label>
        <label class="col-md-9 col-form-label break-word">{{historyValue.projectName}}</label>
      </div>

      @if (!compareItemListMode && metaInfoValue.outdatedInfo) {
        <div class="mb-3 row mb-0">
          <label class="col-md-3 col-form-label">{{'projectVersionHistoryPopup.label.status' | translate}}:</label>
          <label class="col-md-9 col-form-label pb-0 font-weight-bold">{{metaInfoValue.outdatedInfo}}</label>
        </div>
      }

      @if (!compareItemListMode) {
        <div class="mb-3 row mb-0">
          <label class="col-md-3 col-form-label">{{'projectVersionHistoryPopup.label.project_type' | translate}}</label>
          <label class="col-md-9 col-form-label break-word">{{metaInfoValue.projectTypeLabel}}</label>
        </div>
      }

      @if (!compareItemListMode) {
        <div class="mb-3 row mb-0">
          <label class="col-md-3 col-form-label">{{'projectVersionHistoryPopup.label.project_path' | translate}}</label>
          <label class="col-md-9 col-form-label break-word">{{historyValue.projectPath}}</label>
        </div>
      }

      @if (!compareItemListMode) {
        <div class="mb-3 row mb-0">
          <label class="col-md-3 col-form-label">{{'projectVersionHistoryPopup.label.article_number_long' | translate}}</label>
          <label class="col-md-9 col-form-label">{{historyValue.articleNumberLong}}</label>
        </div>
      }

      @if (!compareItemListMode) {
        <div class="mb-3 row mb-0">
          <label class="col-md-3 col-form-label">{{'projectVersionHistoryPopup.label.project_id' | translate}}</label>
          <label class="col-md-9 col-form-label">{{project?.id}}</label>
        </div>
      }

      @if (!compareItemListMode) {
        <div class="mb-3 row mb-0">
          <label class="col-md-3 col-form-label">{{'projectVersionHistoryPopup.label.project_owner_username' | translate}}</label>
          <label class="col-md-9 col-form-label">{{metaInfoValue.projectOwnerUsername}}</label>
        </div>
      }

      @if (!compareItemListMode && metaInfoValue.projectStatus) {
        <div class="mb-3 row mb-0">
          <label class="col-md-3 col-form-label">{{'projectVersionHistoryPopup.label.status' | translate}}</label>
          <div class="col-md-9">
            <div>
              <label class="col-form-label pb-0 font-weight-bold">{{metaInfoValue.projectStatus.status}}</label>
            </div>
            @if (!metaInfoValue.projectStatus.isProjectLocked) {
              <div>
                <label class="col-form-label py-0">{{'projectVersionHistoryPopup.status.version' | translate: {'0': metaInfoValue.projectStatus.versionLabel} }}</label>
              </div>
            }
            @if (!metaInfoValue.projectStatus.isProjectLocked) {
              <div>
                <a class="green u-hover" href="javascript:void(0)" (click)="loadProject(metaInfoValue.projectStatus.projectId, metaInfoValue.projectStatus.projectVersion)">
                  {{'projectVersionHistoryPopup.status.load_configuration' | translate}}
                </a>
              </div>
            }
          </div>
        </div>
      }

      <app-project-version-history-table
        [project]="project"
        [projectHistory]="history()"
        [(selectedEntry)]="selectedEntry"
      />

      <label class="mt-4 mb-0" [innerHTML]="'projectVersionHistoryPopup.message.version_can_be_changed_in_project_options' | translate"></label>
    </div>
  </div>
}
@let selectedEntryValue = selectedEntry();
<div class="modal-footer">
  <button type="button"
    class="btn btn-secondary btn-cancel"
    (click)="onCancel()">
    {{'global.label.close' | translate}}
  </button>
  @if (!compareItemListMode) {
    <button type="button"
      class="btn btn-primary btn-forward"
      [attr.data-testid]="'project-version-history-confirm'"
      [disabled]="!selectedEntryValue || !selectedEntryValue.isAvailable"
      (click)="loadProject(selectedEntryValue.projectId, selectedEntryValue.projectVersion)">
      {{'global.label.load' | translate}}
    </button>
  }
  @if (compareItemListMode) {
    <button type="button"
      class="btn btn-primary btn-forward"
      [attr.data-testid]="'project-version-history-confirm'"
      [disabled]="!selectedEntryValue || !selectedEntryValue.isAvailable"
      (click)="compareItemList(selectedEntryValue)">
      {{'projectVersionHistoryPopup.compareItemListMode.button' | translate}}
    </button>
  }
</div>
